import React from "react";
import ReactDOM from "react-dom";
import AgreementModal from "./agreementModal.jsx";

let notification;
function createModel(props) {
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(React.createElement(AgreementModal, props), div);
    return {
        destroy() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
            notification = null;
        },
    };
}
const notice = (props) => {
    notification = createModel(props);
    return notification;
};
export default {
    show(props) {
        return notice(props);
    },
    hide() {
        if (notification) {
            return notification.destroy();
        }
    },
};
